import { render, staticRenderFns } from "./wfl-posture-perfect-a45.vue?vue&type=template&id=52ad6634"
import script from "./wfl-posture-perfect-a45.vue?vue&type=script&lang=js"
export * from "./wfl-posture-perfect-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports